import React, { useState } from 'react';
import { Button, Container } from '@lmn/design-system';
import styled from 'styled-components';
import useTransportsFetch from '@/app/components/hotel-detail/travel-api/transportsFetch';

const TransportInfo = styled.div`
  display: flex;
  font-size: ${({ theme }) => theme.commons.font.sizes.small};
  font-weight: ${({ theme }) => theme.commons.font.weights.bold};
  justify-content: flex-start;
  padding-left: 1rem;
`;

const FormulaContainer = styled.div`
  padding-left: 1rem;
`;

const Element = styled.div`
  padding-bottom: 0.7rem;
`;

const Line = styled.div`
  padding-bottom: 0.4rem;
`;

type DebugBertolliFormulaProps = {
  flightId: string;
  cheapestPrice?: number;
  price?: number;
  priceFromAPI?: number;
};

const DebugBertolliFormula = (props: DebugBertolliFormulaProps) => {
  const { flightId } = props;

  const { data: travelTransports } = useTransportsFetch();

  const formulaInfo = (travelTransports as FullAvailableTransportResponse)?.formulaInfo;

  const [isFormulaVisible, setIsFormulaVisible] = useState(false);

  const travelData = formulaInfo ? (formulaInfo as { [key: string]: FormulaInfoShown })[flightId] : undefined;

  const toggleFormula = () => {
    setIsFormulaVisible(!isFormulaVisible);
  };

  if (travelData === undefined) {
    return (
      <Container elevation="none" padding={{ top: 1, left: 2 }}>
        <TransportInfo>failed to load formula</TransportInfo>
        <TransportInfo>TransportId: {flightId}</TransportInfo>
      </Container>
    );
  }

  return (
    <Container elevation="none">
      {isFormulaVisible ? (
        <>
          <Button variant="primary" appearance="ghost" onClick={toggleFormula}>
            Hide formula
          </Button>
          <FormulaContainer>
            <Element>Distance to airport coefficient: {travelData.distanceToAirportCoefficient}</Element>
            <Element>
              {Object.entries(travelData.formula).map(([key, value]) => (
                <Line key={key}>
                  <>
                    {key} {value}
                  </>
                </Line>
              ))}
            </Element>
            <Element>Total score: {travelData.totalScore}</Element>
          </FormulaContainer>
          <TransportDebugInfo {...props} />
        </>
      ) : (
        <>
          <Button variant="secondary" onClick={toggleFormula}>
            Show formula
          </Button>
          <TransportDebugInfo {...props} />
        </>
      )}
    </Container>
  );
};

function TransportDebugInfo(props: DebugBertolliFormulaProps) {
  const { price, priceFromAPI, cheapestPrice, flightId } = props;
  return (
    <>
      <TransportInfo>TransportId: {flightId}</TransportInfo>
      <TransportInfo>Cheapest price: {cheapestPrice}</TransportInfo>
      <TransportInfo>Price: {price}</TransportInfo>
      <TransportInfo>Total Price: {priceFromAPI}</TransportInfo>
    </>
  );
}

export default DebugBertolliFormula;
